import React, { useEffect, useState } from 'react'
import { get_hosting_data } from '../../api/Global';
import { IMG_BASE_URL } from '../../config/Base_Url_Config';
import service_shape_3 from "../../assets/images/service-shape-3.png";

const WordPress_Features = () => {
      const [hosting_features_list, set_Hosting_Features_List] = useState([]);
      const [expandedIds, setExpandedIds] = useState(new Set());
      useEffect(() => {
            const handle_get_hosting_features_list = async () => {
                  try {
                        const response = await get_hosting_data();
                        set_Hosting_Features_List(response?.data?.data?.hostings)
                  }
                  catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_hosting_features_list();
      }, [])

      const toggleExpand = (id) => {
            setExpandedIds(prev => {
                  const next = new Set(prev);
                  if (next.has(id)) next.delete(id);
                  else next.add(id);
                  return next;
            });
      };
      return (
            <div>
                  <section className="relative">
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-light/30" />
                        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-blue-500/5 via-transparent to-transparent blur-2xl">
                        </div>
                        <div className="relative py-10 md:py-24 sm:py-32 overflow-hidden">
                              <div className="absolute inset-0 -z-10">
                                    <div className="absolute inset-0 bg-gradient-to-b from-[#fafafa] via-[#fafafa] to-[#fafafa]">
                                    </div>
                                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px]">
                                          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-blue-600/10 blur-[120px] animate-slow-pulse">
                                          </div>
                                    </div>
                              </div>
                              <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                    <div className="mx-auto max-w-2xl text-center mb-10">
                                          <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-50 border border-blue-400/30 mb-4">
                                                <span className="text-sm font-medium text-blue-400"> Innovative features make hosting simple </span>
                                          </div>
                                          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl"><span className="sm:inline md:inline">More than WordPress Hosting</span></h2>
                                    </div>
                                    <div className="relative">
                                          <div className="px-4 -mx-4 md:px-0 md:mx-0">
                                                <div className="flex transition-transform duration-500 ease-out">
                                                      <div className="w-full flex-shrink-0 px-4 md:px-0">
                                                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                                                                  {hosting_features_list?.map((feature) => {
                                                                        // assuming each feature has a unique `id`; otherwise use the index
                                                                        const isExpanded = expandedIds?.has(feature.id);

                                                                        return (
                                                                              <div key={feature.id} className="relative group md:transform-none">
                                                                                    <div className="relative text-center backdrop-blur-xl bg-white rounded-xl p-8 h-full border border-blue-200/10 hover:border-blue-800/50 transition-colors duration-300">
                                                                                          {/* Icon + Title */}
                                                                                          <div className="relative shape_icon mb-8">
                                                                                                <div className="h-28 bg-white rounded-full w-[80px] mx-auto">
                                                                                                      <img src={`${IMG_BASE_URL}/${feature?.icon}`} alt={feature.title} />
                                                                                                </div>
                                                                                                <div className="shpaeview wbhostingi">
                                                                                                      <img src={service_shape_3} alt="" />
                                                                                                </div>
                                                                                          </div>
                                                                                          <h4 className="text-xl hover:text-blue-700 font-bold mb-3">
                                                                                                {feature.title}
                                                                                          </h4>

                                                                                          {/* Description with clamp/toggle */}
                                                                                          <p
                                                                                                className={`text-gray-400 font-normal mb-2 transition-all duration-300 ease-in-out ${isExpanded ? '' : 'line-clamp-3'
                                                                                                      }`}
                                                                                          >
                                                                                                {feature?.description}
                                                                                          </p>

                                                                                          {/* View More/Less button */}
                                                                                          {feature?.description.split(' ').length > 20 && (
                                                                                                <button
                                                                                                      onClick={() => toggleExpand(feature?.id)}
                                                                                                      className="text-blue-500 hover:underline text-sm"
                                                                                                >
                                                                                                      {isExpanded ? 'View Less' : 'View More'}
                                                                                                </button>
                                                                                          )}
                                                                                    </div>
                                                                              </div>
                                                                        );
                                                                  })}
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </section>

            </div>
      )
}

export default WordPress_Features